import React, { useEffect, useState } from "react";
import PageTitle from "../../../jsx/layouts/PageTitle";

const initialForm = {
  top_text: "",
  heading: "",
  description: "",
  points: "",
  button_text: "",
  button_link: "",
  progress1: "",
  progress1_title: "",
  progress2: "",
  progress2_title: "",
};

const AboutDashboard = () => {
  const [aboutData, setAboutData] = useState(null);
  const [form, setForm] = useState(initialForm);
  const [files, setFiles] = useState({
    image1: null,
    image2: null,
  });
  const [editingId, setEditingId] = useState(null);

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  useEffect(() => {
    fetchAbout();
  }, []);

  const fetchAbout = async () => {
    try {
      const res = await fetch("https://admin.drgargevascular.com/backend/about-section");
      const data = await res.json();

      if (data && data.id) {
        setAboutData(data);
        setEditingId(data.id);

        setForm({
          top_text: data.top_text || "",
          heading: data.heading || "",
          description: data.description || "",
          points: data.points || "",
          button_text: data.button_text || "",
          button_link: data.button_link || "",
          progress1: data.progress1 || "",
          progress1_title: data.progress1_title || "",
          progress2: data.progress2 || "",
          progress2_title: data.progress2_title || "",
        });
      } else {
        setAboutData(null);
        setEditingId(null);
        setForm(initialForm);
      }
    } catch (error) {
      console.error("Error fetching about:", error);
    }
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (e) => {
    setFiles({
      ...files,
      [e.target.name]: e.target.files[0],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    Object.keys(form).forEach((key) => {
      formData.append(key, form[key]);
    });

    if (files.image1) formData.append("image1", files.image1);
    if (files.image2) formData.append("image2", files.image2);

    try {
      const url = editingId
        ? `https://admin.drgargevascular.com/backend/about-section/${editingId}`
        : "https://admin.drgargevascular.com/backend/about-section";

      const method = editingId ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        body: formData,
      });

      if (!res.ok) throw new Error("Failed request");

      setMessage(
        editingId
          ? "About section updated successfully!"
          : "About section added successfully!"
      );
      setMessageType("success");

      fetchAbout();

      setTimeout(() => {
        setMessage("");
        setMessageType("");
      }, 4000);
    } catch (error) {
      console.error(error);
      setMessage("Something went wrong. Please try again.");
      setMessageType("error");

      setTimeout(() => {
        setMessage("");
        setMessageType("");
      }, 4000);
    }
  };

  return (
    <>
      <PageTitle activeMenu="About Section" motherMenu="Dashboard" />

      <div className="row">
        <div className="col-xl-12">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-white border-bottom">
              <h4 className="mb-0 fw-bold">
                {editingId ? "Edit About Section" : "Add About Section"}
              </h4>
            </div>

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Top Text</label>
                    <input
                      type="text"
                      name="top_text"
                      className="form-control"
                      value={form.top_text}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Heading</label>
                    <input
                      type="text"
                      name="heading"
                      className="form-control"
                      value={form.heading}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-12 mb-3">
                    <label className="form-label fw-bold">Description</label>
                    <textarea
                      name="description"
                      className="form-control"
                      rows="4"
                      value={form.description}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <div className="col-md-12 mb-3">
                    <label className="form-label fw-bold">
                      Points (one per line)
                    </label>
                    <textarea
                      name="points"
                      className="form-control"
                      rows="5"
                      placeholder={`Advanced non-surgical laser treatments\nMinimally invasive vascular procedures\nImage-guided tumor ablation & embolization`}
                      value={form.points}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Button Text</label>
                    <input
                      type="text"
                      name="button_text"
                      className="form-control"
                      value={form.button_text}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Button Link</label>
                    <input
                      type="text"
                      name="button_link"
                      className="form-control"
                      value={form.button_link}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Image 1</label>
                    <input
                      type="file"
                      name="image1"
                      className="form-control"
                      onChange={handleFileChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-bold">Image 2</label>
                    <input
                      type="file"
                      name="image2"
                      className="form-control"
                      onChange={handleFileChange}
                    />
                  </div>

                  <div className="col-12 mt-3 mb-2">
                    <h5 className="border-bottom pb-2 fw-bold">
                      Progress Section
                    </h5>
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold">Progress 1 %</label>
                    <input
                      type="number"
                      name="progress1"
                      className="form-control"
                      value={form.progress1}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold">
                      Progress 1 Title
                    </label>
                    <input
                      type="text"
                      name="progress1_title"
                      className="form-control"
                      value={form.progress1_title}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold">Progress 2 %</label>
                    <input
                      type="number"
                      name="progress2"
                      className="form-control"
                      value={form.progress2}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label fw-bold">
                      Progress 2 Title
                    </label>
                    <input
                      type="text"
                      name="progress2_title"
                      className="form-control"
                      value={form.progress2_title}
                      onChange={handleChange}
                    />
                  </div>

                  {message && (
                    <div className="col-md-12">
                      <div
                        className={`alert ${
                          messageType === "success"
                            ? "alert-success"
                            : "alert-danger"
                        }`}
                        style={{
                          fontSize: "14px",
                          borderRadius: "8px",
                          padding: "10px 15px",
                        }}
                      >
                        {message}
                      </div>
                    </div>
                  )}

                  <div className="col-md-12 mt-2">
                    <button className="btn btn-primary px-4">
                      {editingId ? "Update About Section" : "Add About Section"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* PREVIEW */}
        <div className="col-xl-12 mt-4">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-white border-bottom">
              <h4 className="mb-0 fw-bold">Current About Preview</h4>
            </div>

            <div className="card-body">
              {aboutData ? (
                <div className="row align-items-center">
                  <div className="col-lg-4">
                    <img
                      src={
                        aboutData.image1
                          ? `https://admin.drgargevascular.com/backend${aboutData.image1}`
                          : ""
                      }
                      alt="about1"
                      style={{
                        width: "100%",
                        borderRadius: "12px",
                        objectFit: "cover",
                        maxHeight: "250px",
                      }}
                    />
                  </div>

                  <div className="col-lg-8">
                    <span className="text-danger fw-bold">
                      {aboutData.top_text}
                    </span>
                    <h2 className="mt-2">{aboutData.heading}</h2>
                    <p className="text-muted">{aboutData.description}</p>

                    <ul>
                      {aboutData.points &&
                        aboutData.points.split("\n").map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                    </ul>
                  </div>
                </div>
              ) : (
                <div className="text-center py-5 text-muted">
                  No About section data found.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutDashboard;